export default __webpack_public_path__ + "static/media/ASBMB_2021_GlyGen_SuperSearch.cc080b25.pdf";